// extracted by mini-css-extract-plugin
module.exports = {"pwInfo":"PublicWelfareCert_pwInfo__3dTXm","certBox":"PublicWelfareCert_certBox__2uiSe","text":"PublicWelfareCert_text__1qEzn"};